export const user_status = {
    id: 1,
    avatar: '/static/thumbs/group-icon.png',
    name: "Gautheir Drewitt",
    notification_count: 3,
    status: 'on'
}

export const groups = [{
    id: 1,
    avatar: '/static/thumbs/group-icon.png',
    title: "ChampYinz",
    description: "Steely: Congrats! @Dre.. takes the crown…",
    members: [{
            id: 1,
            name: 'user',
            chat_point: 26,
            avatar: "/static/thumbs/avatar.png",
            points: [
                1, 1, 1, 1, 1
            ]
        },
        {
            id: 2,
            name: 'user',
            chat_point: 26,
            avatar: "/static/thumbs/group-icon.png",
            points: [
                1, 0, 1, 2, 1
            ]
        },
        {
            id: 3,
            name: 'user',
            chat_point: 26,
            avatar: "/static/thumbs/avatar.png",
            points: [
                1, 0, 1, 2, 0
            ]
        },
        {
            id: 4,
            name: 'user',
            chat_point: 26,
            avatar: "",
            points: [
                1, 0, 2, 2, 1
            ]
        },
        {
            id: 5,
            name: 'user',
            chat_point: 26,
            avatar: "/static/thumbs/avatar.png",
            points: [
                2, 0, 1, 0, 0
            ]
        }
    ],
    status: 'on',
    messages: [{
            id: 1,
            user_id: 1,
            avatar: '/static/thumbs/avatar.png',
            name: 'Klavdia Dedova',
            message: 'You can see me on Fox Sports every week. You don’t need another picture of me!',
        },
        {
            id: 2,
            user_id: 3,
            avatar: '/static/thumbs/avatar.png',
            name: 'Klavdia Dedova',
            message: 'You can see me on Fox Sports every week. You don’t need another picture of me!',
        },
        {
            id: 3,
            user_id: 4,
            avatar: '/static/thumbs/avatar.png',
            name: 'Klavdia Dedova',
            message: 'You can see me on Fox Sports every week. You don’t need another picture of me!',
        },
        {
            id: 4,
            user_id: 2,
            avatar: '/static/thumbs/avatar.png',
            name: 'Klavdia Dedova',
            message: 'You can see me on Fox Sports every week. You don’t need another picture of me!',
        },
        {
            id: 5,
            user_id: '',
            avatar: '/static/thumbs/avatar.png',
            name: 'Klavdia Dedova',
            message: 'You can see me on Fox Sports every week. You don’t need another picture of me!',
        },
        {
            id: 6,
            user_id: 3,
            avatar: '/static/thumbs/avatar.png',
            name: 'Klavdia Dedova',
            message: 'You can see me on Fox Sports every week. You don’t need another picture of me!',
        }
    ]
}];

export const profile = {
    username: 'Dgallagher5',
    firstname: 'David',
    lastname: 'Gallagher',
    birth_date: '1996-04-25',
    address_street_1: '233',
    address_street_2: 'David',
    address_country: 'us',
    address_city: 'New York',
    address_state: 'pt',
    zip_code: '345'
}

export const questions = [{
    id: 1,
    header: 'TROY POLAMALU',
    footer: 'MEL BLOUNT',
    subTitle: 'MORE CAREER ',
    title: 'INTERCEPTIONS',
    thumbnail1: '/static/thumbs/avatar.png',
    thumbnail2: '/static/thumbs/group-icon.png'
},
{
    id: 2,
    header: 'TROY POLAMALU',
    footer: 'MEL BLOUNT',
    subTitle: 'MORE CAREER ',
    title: 'INTERCEPTIONS',
    thumbnail1: '/static/thumbs/avatar.png',
    thumbnail2: '/static/thumbs/group-icon.png'
},
{
    id: 3,
    header: 'TROY POLAMALU',
    footer: 'MEL BLOUNT',
    subTitle: 'MORE CAREER ',
    title: 'INTERCEPTIONS',
    thumbnail1: '/static/thumbs/avatar.png',
    thumbnail2: '/static/thumbs/group-icon.png'
}];

export const medias = {
    gifs: {
        group1: [
            {
                id: 1,
                thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTnrdT9HCG_y_pFzIlsgLmgnA-kD_oqSt5jHQ&usqp=CAU',
            },
            {
                id: 1,
                thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSfBLT5WwuIDjvv1uBjh4axCiy7M4Oyxwpcmg&usqp=CAU',
            },
            {
                id: 1,
                thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ3TenDUtBXk-X-boGbEX5GmfdjBQbwvFC5BA&usqp=CAU',
            },
            {
                id: 1,
                thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTnrdT9HCG_y_pFzIlsgLmgnA-kD_oqSt5jHQ&usqp=CAU',
            },
            {
                id: 1,
                thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSfBLT5WwuIDjvv1uBjh4axCiy7M4Oyxwpcmg&usqp=CAU',
            },
            {
                id: 1,
                thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ3TenDUtBXk-X-boGbEX5GmfdjBQbwvFC5BA&usqp=CAU',
            },
            {
                id: 1,
                thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTnrdT9HCG_y_pFzIlsgLmgnA-kD_oqSt5jHQ&usqp=CAU',
            },
            {
                id: 1,
                thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSfBLT5WwuIDjvv1uBjh4axCiy7M4Oyxwpcmg&usqp=CAU',
            },
        ],
        group2: [
            {
                id: 1,
                thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRijoMqmHTD6xmI-90PZmqzycCTXMfZgvn7Hw&usqp=CAU',
            },
            {
                id: 1,
                thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTgAHK4zt0OK0iZ2KmIMmaESvwau8qNGgOK9g&usqp=CAU',
            },
            {
                id: 1,
                thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvjvoRm6asb81bKRR4RHnBzPVJxc7RleALmQ&usqp=CAU',
            },
            {
                id: 1,
                thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRijoMqmHTD6xmI-90PZmqzycCTXMfZgvn7Hw&usqp=CAU',
            },
            {
                id: 1,
                thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTgAHK4zt0OK0iZ2KmIMmaESvwau8qNGgOK9g&usqp=CAU',
            },
            {
                id: 1,
                thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvjvoRm6asb81bKRR4RHnBzPVJxc7RleALmQ&usqp=CAU',
            },]
        },
    photos: [
        {
            id: 1,
            thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRijoMqmHTD6xmI-90PZmqzycCTXMfZgvn7Hw&usqp=CAU',
        },
        {
            id: 1,
            thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTgAHK4zt0OK0iZ2KmIMmaESvwau8qNGgOK9g&usqp=CAU',
        },
        {
            id: 1,
            thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvjvoRm6asb81bKRR4RHnBzPVJxc7RleALmQ&usqp=CAU',
        },
        {
            id: 1,
            thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRijoMqmHTD6xmI-90PZmqzycCTXMfZgvn7Hw&usqp=CAU',
        },
        {
            id: 1,
            thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTgAHK4zt0OK0iZ2KmIMmaESvwau8qNGgOK9g&usqp=CAU',
        },
        {
            id: 1,
            thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvjvoRm6asb81bKRR4RHnBzPVJxc7RleALmQ&usqp=CAU',
        }
    ],
    news: {
        group1: [
            {
                id: 1,
                content: 'Epicurus in malis dolor, non numquam eius modi tempora incidunt, ut de homine sensibus reliqui nihil oportere exquisitis rationibus sanciret des oka…',
                author: 'Homura Yunosuke',
                source: 'twitter.com'
            },
            {
                id: 1,
                thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRijoMqmHTD6xmI-90PZmqzycCTXMfZgvn7Hw&usqp=CAU',
                content: 'Epicurus in malis dolor, non numquam eius modi tempora incidunt, ut de homine sensibus reliqui nihil oportere exquisitis rationibus sanciret des oka…',
                author: 'Homura Yunosuke',
                source: 'twitter.com'
            }
        ],
        group2: [
            {
                id: 1,
                thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRijoMqmHTD6xmI-90PZmqzycCTXMfZgvn7Hw&usqp=CAU',
                content: 'Epicurus in malis dolor, non numquam eius modi tempora incidunt, ut de homine sensibus reliqui nihil oportere exquisitis rationibus sanciret des oka…',
                author: 'Homura Yunosuke',
                source: 'twitter.com'
            },
            {
                id: 1,
                thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRijoMqmHTD6xmI-90PZmqzycCTXMfZgvn7Hw&usqp=CAU',
                content: 'Epicurus in malis dolor, non numquam eius modi tempora incidunt, ut de homine sensibus reliqui nihil oportere exquisitis rationibus sanciret des oka…',
                author: 'Homura Yunosuke',
                source: 'twitter.com'
            }
        ]
    }

    
}